@if (
    !commonDataService.user.isReadOnly &&
    (reply.id ||
        (!reply.isDeleted &&
            isInboxElementVisible(
                commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader?.forwardAction
            )))
) {
    <div
        dropdown
        container="body"
        [placement]="!isReplyMenuDropUp ? 'bottom left' : 'top left'"
        [dropup]="isReplyMenuDropUp">
        <div
            [tooltip]="'Copied' | translate"
            placement="bottom"
            #copiedTooltip="bs-tooltip"
            [tooltipFadeDuration]="1000"
            [triggers]="''"
            container="body">
            <button
                #replyMenuBtn
                class="btn btn-icon btn-transparent"
                data-testid="reply-actions-menu"
                dropdownToggle
                type="button"
                aria-controls="dropdown-basic">
                <sb-inline-svg
                    class="icon"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
                </sb-inline-svg>
            </button>
        </div>

        <ul
            id="dropdown-basic"
            *dropdownMenu
            class="dropdown-menu"
            [ngClass]="{ 'dropdown-menu-right': reply.isByTeam, 'dropdown-menu-left': !reply.isByTeam }"
            role="menu"
            aria-labelledby="button-basic">
            @if (reply.id) {
                <li role="menuitem">
                    <button class="dropdown-item" type="button" (click)="parent.openAddTagsModal(reply)" translate>
                        Add tags
                    </button>
                </li>
                <li role="menuitem">
                    <button class="dropdown-item" type="button" (click)="parent.openNoteEditor(reply, true)" translate>
                        Add note
                    </button>
                </li>
            }
            @if (!reply.isDeleted) {
                @if (
                    isInboxElementVisible(
                        commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader?.forwardAction
                    )
                ) {
                    <li role="menuitem">
                        <button
                            class="dropdown-item"
                            data-testid="forward-message-action"
                            type="button"
                            (click)="
                                forwardMessageService.openForwardForm(
                                    reply,
                                    reply.id ? forwardEntityTypeEnum.reply : forwardEntityTypeEnum.ticketMessage,
                                    ticket
                                )
                            "
                            translate>
                            Forward message
                        </button>
                    </li>
                }
                @if (reply.id) {
                    <li role="menuitem">
                        <button
                            type="button"
                            class="dropdown-item"
                            ngxClipboard
                            [cbContent]="replyUrl"
                            (click)="copiedTooltip.show(); copiedTooltip.hide()"
                            translate>
                            Copy link
                        </button>
                    </li>
                }
            }
            @if (reply.id && !reply.isDeleted) {
                <li
                    role="menuitem"
                    dropdown
                    triggers="mouseover"
                    container="body"
                    class="dropstart"
                    [placement]="!isReminderMenuDropUp ? 'left top' : 'left bottom'"
                    [dropup]="isReminderMenuDropUp">
                    <button
                        dropdownToggle
                        class="dropdown-item dropdown-toggle"
                        type="button"
                        (click)="$event.stopPropagation()"
                        translate>
                        Remind
                    </button>
                    <ul *dropdownMenu class="dropdown-menu" role="menu" style="right: 0">
                        <app-reminder-menu
                            [isReminderAdded]="!!reply.reminder"
                            (remindClick)="remindClick.emit($event)"
                            (removeReminderClick)="removeReminderClick.emit($event)"
                            (pickDateAndTimeClick)="pickDateAndTimeClick.emit($event)"></app-reminder-menu>
                    </ul>
                </li>
            }
        </ul>
    </div>
}
